import { BCDataGrid } from '@bimser/components';
import DataGrid2 from '../..';
import { IControlProperties } from '../../../../../../entities';
import { IDataGridColumn } from '../../entities';
import { calculateCellValueForRelationGrid } from './commonHelpers';
import { CustomizedDxColumn } from './generateColumns';

export const setDateTimePicker = (bcDataGrid: DataGrid2, dxColumn: CustomizedDxColumn) => {
	if (bcDataGrid.dataSourceType === 'relation') {
		dxColumn.calculateCellValue = calculateCellValueForRelationGrid;
	}
};

export const getDateTimePickerComponents = (
	bcDataGrid: DataGrid2,
	bcColumn: IDataGridColumn<IControlProperties>
) => [
	<BCDataGrid.Components.Format
		key="format"
		formatter={bcDataGrid.__formatterCache.get(bcColumn.name)}
	/>
];
